<template>
  <div>
    <div>
      <div v-if="loaded && liveReceipts.length === 0">
        <div class="alert alert-primary" role="alert">رسید پخشی یافت نشد.</div>
      </div>
    </div>
    <div v-if="loaded && liveReceipts.length" class="card card-custom gutter-b">
      <div class="card-body">
        <div class="table-responsive rounded border-1">
          <table
            class="table table-head-custom table-head-bg table-borderless table-vertical-center"
          >
            <thead>
              <tr>
                <th>کد</th>
                <th>کد پخش</th>
                <th>برنامه‌</th>
                <th v-if="isAdmin">کاربر</th>
                <th v-if="isCompany || isAdmin">مصرف کننده</th>
                <th>مبلغ (ریال)</th>
                <th>تاریخ</th>
                <th>عملیات</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="liveReceipt in liveReceipts" :key="liveReceipt.id">
                <td dir="ltr">{{ liveReceipt.id }}</td>
                <td dir="ltr" class="text-nowrap">
                  <router-link
                    :to="{
                      name: 'receipts-lives-show',
                      params: { id: liveReceipt.id }
                    }"
                    class="text-primary"
                  >
                    {{ liveReceipt.live.id }}
                  </router-link>
                </td>
                <td class="text-nowrap">
                  <router-link
                    :to="{
                      name: 'programs-show',
                      params: { id: liveReceipt.program.id }
                    }"
                    class="text-primary"
                  >
                    {{ liveReceipt.program.name }}
                  </router-link>
                </td>
                <td v-if="isAdmin" class="text-nowrap">
                  <router-link
                    :to="{
                      name: 'admin-users-show',
                      params: { id: liveReceipt.user_id }
                    }"
                    class="text-primary"
                  >
                    {{ gFullName(liveReceipt.user) || "_" }}
                  </router-link>
                </td>
                <td v-if="isCompany || isAdmin" class="text-nowrap">
                  <router-link
                    v-if="liveReceipt.consumer_id && isAdmin"
                    :to="{
                      name: 'admin-users-show',
                      params: { id: liveReceipt.consumer_id }
                    }"
                    class="text-primary"
                  >
                    {{ gFullName(liveReceipt.consumer) || "_" }}
                  </router-link>
                  <router-link
                    v-if="liveReceipt.consumer_id && isCompany"
                    :to="{
                      name: 'company-users-show',
                      params: { id: liveReceipt.consumer_id }
                    }"
                    class="text-primary"
                  >
                    {{ gFullName(liveReceipt.consumer) || "_" }}
                  </router-link>
                </td>
                <td dir="ltr">{{ numberFormat(liveReceipt.total) }}</td>
                <td dir="ltr" class="text-nowrap">
                  {{ formatDate(liveReceipt.created_at) }}
                </td>
                <td class="text-nowrap">
                  <router-link
                    :to="{
                      name: receiptRouteName,
                      params: { id: liveReceipt.id }
                    }"
                    class="btn btn-xs btn-outline-primary"
                  >
                    <i class="flaticon-eye"></i>
                    مشاهده
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="overflow-auto mt-5" v-if="liveReceiptsPagination.lastPage > 1">
      <b-pagination
        v-model="liveReceiptsPagination.currentPage"
        :total-rows="liveReceiptsPagination.total"
        :per-page="liveReceiptsPagination.perPage"
        aria-controls="my-table"
        @input="updateLiveReceipts()"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import {
  FETCH_LIVE_RECEIPTS,
  FETCH_ADMIN_LIVE_RECEIPTS
} from "@/core/services/store/receipts/live.module";
import { mapGetters } from "vuex";

export default {
  name: "liveReceipts",
  data() {
    return {
      loaded: false,
      isCompany: this.$route.name.startsWith("company"),
      isAdmin: this.$route.name.startsWith("admin"),
      receiptRouteName: "receipts-lives-show",
      action: FETCH_LIVE_RECEIPTS
    };
  },
  mounted() {
    this.setBreadcrumbs();
    this.$store.dispatch(SET_ACTIONS, {});

    if (this.isCompany) {
      this.receiptRouteName = "company-receipts-lives-show";
    }
    if (this.isAdmin) {
      this.receiptRouteName = "admin-receipts-lives-show";
      this.action = FETCH_ADMIN_LIVE_RECEIPTS;
    }

    this.updateLiveReceipts();
  },
  computed: {
    ...mapGetters(["liveReceipts", "liveReceiptsPagination"])
  },
  methods: {
    updateLiveReceipts() {
      this.loaded = false;

      this.$store
        .dispatch(this.action)
        .then(() => {
          this.loaded = true;
        })
        .catch(() => {
          this.loaded = true;
        });
    },
    setBreadcrumbs() {
      let items = [];
      if (this.isCompany) {
        items.push({
          title: this.currentUserProperty.title ?? "شرکت",
          route: { name: "company-dashboard" }
        });
      }
      if (this.isAdmin) {
        items.push({
          title: "مدیریت",
          route: { name: "admin-dashboard" }
        });
      }

      items.push({ title: "رسیدهای پخش" });

      this.$store.dispatch(SET_BREADCRUMB, items);
    }
  },
  watch: {
    "$route.name": {
      handler: function(to, from) {
        if (from !== undefined) {
          this.eventHub.$emit("re_render_page", this);
        }
      },
      deep: true,
      immediate: true
    }
  }
};
</script>
